module.exports = __webpack_public_path__ + "static/media/1-2.837547d7.png";